import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_FORM_PDF_REQUEST = 'GET_FORM_PDF_REQUEST';
export const GET_FORM_PDF_SUCCESS = 'GET_FORM_PDF_SUCCESS';
export const GET_FORM_PDF_FAILURE = 'GET_FORM_PDF_FAILURE';
export const GET_FORM_PDF_CLEAR = 'GET_FORM_PDF_CLEAR';

function request(formType) {
  return {
    type: GET_FORM_PDF_REQUEST,
    isFetchingPdfForm: true,
    downloadRequestFormType: formType
  };
}

function receive(pdfData) {
  return {
    type: GET_FORM_PDF_SUCCESS,
    isFetchingPdfForm: false,
    downloadRequestFormType: null,
    pdfData,
  };
}

function reject() {
  return {
    type: GET_FORM_PDF_FAILURE,
    isFetchingPdfForm: false,
    downloadRequestFormType: null
  };
}

function clear() {
  return {
    type: GET_FORM_PDF_CLEAR
  };
}

export function getPreviewPdf(formId, formType, intl) {
  return (dispatch) => {
    dispatch(request(formType));

    const promise = () => ApiService
      .getPreviewPdf(formId, { responseType: 'arraybuffer' })
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          const status = error.response && error.response.status;
          if (status !== 401) {
            dispatch(handleException(
              { response: { data: { code: 500, message: intl.formatMessage({ id: 'formPreview.downloadError' }) } } },
              reject,
              !status || (status !== 404 && status !== 401)
            ));
          }
        }
      });
    return promise();
  };
}

export function getFormGroupFormPreviewPdf(formGroupId, formType, intl) {
  return (dispatch) => {
    dispatch(request(formType));

    const promise = () => ApiService
      .getFormGroupFormPreviewPdf(formGroupId, formType, { responseType: 'arraybuffer' })
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          const status = error.response && error.response.status;
          if (status !== 401) {
            dispatch(handleException(
              { response: { data: { code: 500, message: intl.formatMessage({ id: 'formPreview.downloadError' }) } } },
              reject,
              !status || (status !== 404 && status !== 401)
            ));
          }
        }
      });
    return promise();
  };
}

export function getFormPdf(formId, formType, intl) {
  return (dispatch) => {
    dispatch(request(formType));

    return ApiService
      .getFormPdf(formId, { responseType: 'arraybuffer' })
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        const status = error.response && error.response.status;
        if (status !== 401) {
          dispatch(handleException(
            { response: { data: { code: 500, message: intl.formatMessage({ id: 'form.downloadError' }) } } },
            reject,
            !status || (status !== 404 && status !== 401)
          ));
        }
      });
  };
}

export function getFormGroupPdf(formGroupId, formType, intl) {
  return (dispatch) => {
    dispatch(request(formType));

    return ApiService
      .getFormGroupPdf(formGroupId, formType, { responseType: 'arraybuffer' })
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        const status = error.response && error.response.status;
        if (status !== 401) {
          dispatch(handleException(
            { response: { data: { code: 500, message: intl.formatMessage({ id: 'form.downloadError' }) } } },
            reject,
            !status || (status !== 404 && status !== 401)
          ));
        }
      });
  };
}

export function clearPdfDownload() {
  return (dispatch) => {
    dispatch(clear());
  };
}
